import React , { useState, useEffect } from 'react';
import styled from "styled-components";
import {
Nav,
NavLink,
Bars,
NavMenu,
NavBtn, 
} from './topNavbarStyle';
import '../../index.css';
import { selectUser } from '../auth/userAuth';
import { useSelector,useDispatch } from 'react-redux'; 
import { logout } from '../auth/userAuth'; 
import { toast} from "react-toastify";
import { useNavigate } from 'react-router-dom'; 
import axios from 'axios';
import LazyImage from "react-lazy-progressive-image";
import { socket } from "../../components/socket/server.js"; 
import SlotCounter from 'react-slot-counter';
const logo = require('../../assets/ic_launcher_round.png')
const logoPlaceholder = require('../../assets/ic_launcher_round_micro.png')
const userImg = require('../../assets/ui_profile_logo_96x96.png')
const userImgPlaceholder = require('../../assets/ui_profile_logo_96x96_micro.png')
const seen = require('../../assets/ui_seen_36x.png') 
const unseen = require('../../assets/ui_unseen_36x.png') 

 
  function ExpandedSideBar(props) {  
	return (
		<div className="sidenav" style={{ width: props.isActive? '200px':'0px'  }}>
		<NavLink to='/home'  onClick={() => { props.setIsActive(isActive => !isActive); }} >Home</NavLink> 
		<NavLink to='/privacyPolicy'  onClick={() => { props.setIsActive(isActive => !isActive); }} >Privacy Policy</NavLink> 
		{props.currentUser ? (<NavLink to='/signIn' onClick={(e)=>{logoutHandle(props.dispatch,e); props.setIsActive(isActive => !isActive);}} >LogOut</NavLink>) :(<NavLink to='/signIn'  onClick={() => { props.setIsActive(isActive => !isActive); }} >LogIn</NavLink>)}   
		</div> 
	);
  }

  const Image = styled.img`
  transition: all 0.25s ease;
  opacity: ${props => (props.loading ? 0.2 : 1)};
  `; 
export const logoutHandle= (dispatch,e) =>{
	e.preventDefault(); 
	dispatch(logout());
	toast.success("LogOut Successfully!");
}

const LiveUsers = ({currentUser}) => {
		const [connected, setConnected] = useState(socket.connected);
		const [liveCountUsers, setLiveCountUsers] = useState(0);
		useEffect(() => {
			if (currentUser && currentUser.emailId) {
			socket.auth = {
				userId: currentUser.emailId,
				role: "webApp",
			};
	
			if (!socket.connected) {
				socket.connect();
			}
			} else {
			socket.disconnect();
			}
	
			const onConnect = () => setConnected(true);
			const onDisconnect = () => setConnected(false);
			const onLiveSignal = (data) => {
				console.log("Live Count:", data);
				setLiveCountUsers(data);
			};  
	
			socket.on("connect", onConnect);
			socket.on("disconnect", onDisconnect);
			socket.on("liveCountSignal", onLiveSignal); 
	
			return () => {
			socket.off("connect", onConnect);
			socket.off("disconnect", onDisconnect);
			};
		}, [currentUser]);
	
	return (
		(currentUser && (currentUser.name!=null)) && 
		<div>  
			<LazyImage 
					placeholder={connected?seen:unseen} 
					src={connected?seen:unseen} 
				> 
				{(src, loading, isVisible) => 
						<Image   
							src={src}   
							title={"Live Users"} 
							alt={"Live Users"}  
							id='navHeaderLiveUserStyle' 
							/>}
				</LazyImage>
				<b id='navHeaderLiveUserTextStyle'>
					<SlotCounter value={liveCountUsers}  
							 /> 
				</b>
							 </div>
	);
}

const Navbar = () => {
	const currentUser = useSelector(selectUser);
	const [isActive, setIsActive] = useState(false);
	const [isPreviewUserImage, setIsPreviewUserImage] = useState(false);
	const [imageUser, setImage] = useState("");  
	const [largeImageUser, setLargeImage] = useState("");  
	
	const showUserImage = () => setIsPreviewUserImage(true);
	const hideUserImage = () => setIsPreviewUserImage(false);
  
	const dispatch= useDispatch();
	const navigate = useNavigate(); 

	const userName= () =>{
		var userName="Unknown";
		if (currentUser && (currentUser.name!=null)){
			userName= currentUser.name.substring(1); 
			if(userName.length>0){userName=userName.substring(0,1).toUpperCase()+userName.substring(1);} 
		}
		return userName;  
	} 

	const getUserImage =  (size) => { 
		const domain= "https://youtubersclan.com"  
		const port="40000"; 
		const route="api/youtubersClan/file.data"; 
		if (currentUser && (currentUser.name!=null)){
			axios.get(domain+":"+port+"/"+route, { 
				headers: { 
					datarequest: 'getFile',
					datatype: 'userProfile',
					datacontenttype: size,
					id:currentUser.emailId,
					uid:currentUser.uid,
					userid:currentUser.emailId
				},
				responseType: 'arraybuffer'
			})
			.then((res) => { 
				let data = new Uint8Array(res.data);
				let raw = String.fromCharCode.apply(null, data);
				let base64 = btoa(raw);
				let src = "data:image;base64," + base64;
				if(size==='Images/512x'){
					setLargeImage(src); 
				}else{
					setImage(src); 
				}
			});
		}else{
			if(size==='Images/512x'){
				setLargeImage(""); 
			}else{
				setImage(""); 
			}
		}
		return userImgPlaceholder;
	}

return (
	<>  
	<ExpandedSideBar isActive={isActive} setIsActive={setIsActive} currentUser={currentUser} dispatch={dispatch}/> 
	<div className='header'>
		<Nav>
			<Bars onClick={() => { setIsActive(isActive => !isActive); }} /> 				  
			<NavMenu>  
				<div className='navHeaderLogo'>  
					<NavLink to='/' >
						<div className='navHeaderLogoImgBox'> 
							<div className='navHeaderLogoImg'> 
								<LazyImage
									placeholder={logoPlaceholder} 
									src={logo} 
								> 
									{(src, loading, isVisible) => 
									<Image   
										src={src}  
										title={"Home"} 
										alt={"Youtuber Clan Logo"}  
										id='navHeaderLogoStyle' 
									/>}
								</LazyImage>
							</div>
						</div>
						<div className='navHeaderLogoTextBox'><div className='navHeaderLogoText'>Youtubers Clan</div> </div>
					</NavLink>
					<LiveUsers currentUser={currentUser}></LiveUsers>
				</div>
			</NavMenu> 
			<div className='navHeaders'> 
				<NavBtn>
					<NavLink to='/home' >Home</NavLink> 
					<NavLink to='/privacyPolicy' >Privacy Policy</NavLink> 
					{currentUser ? (<NavLink to='/signIn' onClick={(e)=>{logoutHandle(dispatch,e);}} >LogOut</NavLink>) :(<NavLink to='/signIn'>LogIn</NavLink>)}   
				</NavBtn> 
				<NavLink >   
					<LazyImage
						placeholder={currentUser ?  getUserImage('Images/64x') : userImgPlaceholder } 
						src={currentUser ? imageUser :userImg } 
					>
        				{(src, loading, isVisible) => 
						<Image 
							onClick={(e)=> 
							{
							e.preventDefault(); 
							if(currentUser){ 
							toast.success( "Welcome " + (userName()) +"!" );
							showUserImage() 
							}else{
								navigate('/signIn')	
							}}
							}
							src={src} 
							loading={loading ? "lazy" : undefined}
							effect="blur"  
							title={userName()} 
							alt={userName()}  
							id='signInImg' 
						/>}
					</LazyImage>
				</NavLink>
			</div>
		</Nav>
	</div> 
	{isPreviewUserImage && 
	( <div
			style={{
					position: "fixed",
					top: 0,
					left: 0,
					width: "100vw",
					height: "100vh",
					backgroundColor: "rgba(0, 0, 0, 0.25)",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					zIndex: 10,
					cursor: "default",     
					userSelect: "none",   
				}}
				onClick={hideUserImage} 
			  >
				<div
					style={{
					width: "365px",
					height: "365px",
					borderRadius: "10%",  
					overflow: "hidden",
					boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
					cursor: "default",
					}}
					onClick={(e) => e.stopPropagation()}  > 

				<LazyImage
						placeholder={currentUser ?  getUserImage('Images/512x') : userImgPlaceholder } 
						src={currentUser ? largeImageUser :userImg } >
        				{(src, loading, isVisible) => 
						<Image   
							style={{
							width: "360px",     
							height: "360px",      
							objectFit: "cover",
							borderRadius: "10%",    
							cursor: "default",     
							userSelect: "none",    
							}}
							src={src} 
							loading={loading ? "lazy" : undefined}
							effect="blur"  
							title={userName()} 
							alt={userName()}  
						/>}
					</LazyImage>
				</div>
  </div>
		)
	} 
	</>
);
};

export default Navbar; 
